module.exports = __webpack_public_path__ + "static/media/commercialhvac.5a6f2469.jpg";